<script>
import {defineComponent} from 'vue'
import api from "@/api/api"
import {formatIsoToCustom} from "@/common/formatToIso";
import {processObjectNullValues} from "@/common/processObjectNullValues";
import TicketLayouts from "@/components/Tickets/layouts/TicketLayouts.vue";

export default defineComponent({
  name: "TicketCategories",
  components: {TicketLayouts},
  data() {
    return {
      categoryParams: {
        name: "",
        enabled: true,
        type_id: null
      },
      isOpenCreateCategory: false,
      search: '',
      ticketCategories: [],
      isLoading: false,
      typeOptions: [],
      sidebarFields: [],
      selectedCategory: {},
      isTypeLoading: false,
      isSidebarLoading: false,
      fields: [
        {key: 'id', label: '№', sortable: true},
        {key: 'date', label: 'Дата', sortable: true},
        {key: 'name', label: 'Название'},
        {key: 'enabled', label: 'Включено',},
        {key: 'username', label: 'Кем создан',},
        // {key: 'description', label: 'Описание',},
        {key: "actions", label: "Действия"}
      ]
    }
  },
  computed: {
    rows() {
      const query = this.search.trim().toLowerCase()
      if (!query) return this.ticketCategories || []
      return (this.ticketCategories || []).filter(item =>
          [item.id, item.name].some(field => String(field ?? '').toLowerCase().includes(query)))
    },
  },
  methods: {
    async getTypes() {
      this.isTypeLoading = true;
      try {
        const res = await api.tickets.getListTicketTypes()
        this.typeOptions = res.data?.data.map((type) => ({
          value: type.id,
          text: type.name,
        }))
        this.isTypeLoading = false;
      } catch (e) {
        this.isTypeLoading = false;
      } finally {
        this.isTypeLoading = false;
      }

    },
    async getTicketCategories() {
      this.isLoading = true;
      try {
        const res = await api.tickets.getListTicketCategories({})
        this.ticketCategories = res.data?.data.map((type) => processObjectNullValues({
          id: type.id,
          date: formatIsoToCustom(type.created_at),
          name: type.name,
          enabled: type.enabled ? 'Да' : "Нет",
          username: type.created_by?.username || type.created_by?.email,
          description: type.description,
          _original: type
        }));
        this.isLoading = false;
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false;
      }
    },
    async createCategory() {
      if (!this.categoryParams.name === "") {
        this.$bvToast.toast('Введите название', {
          title: "Валидация",
          variant: "danger",
        })
        return false
      }
      // if (!this.categoryParams.type_id) {
      //   this.$bvToast.toast('Выберите тип', {
      //     title: "Валидация",
      //     variant: "danger",
      //   })
      //   return false
      // }
      try {
        const res = await api.tickets.createTicketCategory(this.categoryParams)
        const newCategory = res.data?.data

        const formattedCategory = processObjectNullValues({
          id: newCategory.id,
          date: formatIsoToCustom(newCategory.created_at),
          name: newCategory.name,
          enabled: newCategory.enabled ? 'Да' : "Нет",
          username: newCategory.created_by?.username || newCategory.created_by?.email,
          description: newCategory.description,
          _original: newCategory
        })

        this.ticketCategories.push(formattedCategory)
        this.$bvModal.hide('create-categories')
        this.isOpenCreateCategory = false
        this.categoryParams.name = ""
        this.categoryParams.enabled = false
      } catch (e) {
        console.log(e)
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async deleteCategory(category) {
      try {
        if (category && category.id) {
          await api.tickets.deleteTicketCategory(category?.id)
        }
        this.ticketCategories = this.ticketCategories.filter(item => item.id !== category.id)
      } catch (e) {
        console.log('deleting category error: ', e)
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async openEditSidebar(item) {
      await this.getTypes()
      this.sidebarFields = [
        {
          key: 'name',
          label: 'Название',
          type: 'text',
          placeholder: 'Введите название',
          required: true
        },
        {
          key: 'enabled',
          label: 'Включено',
          type: 'checkbox',
          default: true
        }
      ]
      this.selectedCategory = {
        id: item.id,
        name: item._original?.name || item.name,
        type_id: item._original?.type_id,
        description: item._original?.description || '',
        enabled: item._original?.enabled ?? true
      }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    async handleSaveCategory(formData) {
      this.isSidebarLoading = true
      try {
        const res = await api.tickets.updateTicketCategory(this.selectedCategory.id, {
          name: formData.name,
          enabled: formData.enabled
        })
        const updatedCategory = res.data?.data || formData
        const index = this.ticketCategories.findIndex(cat => cat.id === formData.id)
        if (index !== -1) {
          const oldItem = this.ticketCategories[index]
          this.$set(this.ticketCategories, index, processObjectNullValues({
            id: updatedCategory.id,
            date: oldItem.date,
            name: updatedCategory.name,
            enabled: updatedCategory.enabled ? 'Да' : 'Нет',
            username: oldItem.username,
            description: updatedCategory.description,
            _original: updatedCategory
          }))

        }
        this.$bvToast.toast('Категория успешно обновлена', {
          title: "Успех",
          variant: "success",
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        this.selectedCategory = null
      } catch (e) {
        console.log('updating category error: ', e)
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      } finally {
        this.isSidebarLoading = false
      }
    }
  },
  watch: {
    isOpenCreateCategory() {
      if (this.isOpenCreateCategory === true) {
        this.getTypes()
      }
    }
  },
  mounted() {
    this.getTicketCategories()
  }
})
</script>

<template>
  <TicketLayouts title="Редактировать категорию"
                 :sidebar-fields="sidebarFields"
                 :sidebar-item="selectedCategory"
                 :sidebar-loading="isSidebarLoading"
                 @sidebar-save="handleSaveCategory"
  >
    <div class="tr">
      <Breadcrumbs main="Тикеты" title="Категории обращений"/>

      <div class="container-fluid tr-wrap">
        <div class="tr-toolbar">
          <div class="tr-search">
            <i class="fa fa-search tr-search__icon"></i>
            <input type="search" class="tr-search__input" v-model="search"
                   placeholder="ID или название категории…" @keydown.esc.prevent="search = ''"/>
            <button v-if="search" type="button" class="tr-search__clear" @click="search = ''">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <span class="tr-spacer"></span>

          <button type="button" class="tr-icon-btn" :class="{ 'is-spin': isLoading }"
                  @click="getTicketCategories()" v-b-tooltip.hover.bottom="'Обновить'">
            <i class="fa fa-refresh"></i>
          </button>

          <button type="button" class="tr-btn-primary" @click="isOpenCreateCategory = true">
            <i class="fa fa-plus"></i> Создать категорию
          </button>
        </div>

        <div class="tr-panel">
          <div v-if="isLoading" class="tr-skeleton">
            <div v-for="n in 5" :key="'sk' + n" class="tr-skeleton__row">
              <span class="tr-sk"></span><span class="tr-sk"></span>
              <span class="tr-sk"></span><span class="tr-sk"></span><span class="tr-sk"></span>
            </div>
          </div>

          <div v-else-if="!rows.length" class="tr-empty">
            <div class="tr-empty__art"><i class="fa fa-tags"></i></div>
            <div class="tr-empty__title">{{ search ? 'Ничего не нашлось' : 'Категорий нет' }}</div>
            <div class="tr-empty__text">
              {{ search ? 'Попробуйте изменить запрос.' : 'Категории уточняют тему обращения внутри типа.' }}
            </div>
            <button type="button" class="tr-btn-primary" @click="isOpenCreateCategory = true">
              <i class="fa fa-plus"></i> Создать категорию
            </button>
          </div>

          <div v-else class="tr-table-wrap">
            <table class="tr-table">
              <thead>
              <tr>
                <th>ID</th>
                <th>Название</th>
                <th>Включена</th>
                <th>Кем создана</th>
                <th>Создана</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in rows" :key="'cat' + item.id">
                <td><span class="tr-id">#{{ item.id }}</span></td>
                <td><span class="tr-name">{{ item.name }}</span></td>
                <td>
                  <span class="tr-badge" :class="item.enabled === 'Да' ? 'tr-badge--ok' : 'tr-badge--off'">
                    {{ item.enabled === 'Да' ? 'Включена' : 'Выключена' }}
                  </span>
                </td>
                <td>{{ item.username }}</td>
                <td class="tr-num">{{ item.date }}</td>
                <td>
                  <div class="tr-actions">
                    <button type="button" class="tr-act" @click="openEditSidebar(item)"
                            v-b-tooltip.hover.top="'Редактировать'">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button type="button" class="tr-act tr-act--danger" @click="deleteCategory(item)"
                            v-b-tooltip.hover.top="'Удалить'">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="isOpenCreateCategory" title="Новая категория" hide-footer>
      <b-form @submit.prevent="createCategory">
        <label class="font-weight-bold">Название</label>
        <b-form-input v-model="categoryParams.name" placeholder="Например: Оплата"/>
        <label class="font-weight-bold mt-3">Тип обращения</label>
        <b-form-select v-model="categoryParams.type_id" :options="typeOptions" :disabled="isTypeLoading"/>
        <b-form-checkbox class="mt-3" v-model="categoryParams.enabled">Включена</b-form-checkbox>
        <b-button class="mt-3 w-100" variant="primary" type="submit">Создать</b-button>
      </b-form>
    </b-modal>
  </TicketLayouts>
</template>

<style scoped lang="scss">
@import "~@/assets/scss/ticket-ref.scss";
</style>
